import { Price } from '@/interfaces/price';

export class TaxedPrice {
  private readonly ht: Price;
  private readonly ttc: Price;

  constructor(ht: Price | undefined, ttc: Price | undefined, defaultUnit: string) {
    this.ht = ht ?? {
      value: 0,
      unit: `${defaultUnit}HT`
    };
    this.ttc = ttc ?? {
      value: 0,
      unit: `${defaultUnit}TTC`
    };
  }

  get prices(): Price[] {
    return [this.ht, this.ttc];
  }
}
